import React, { useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowRight, CalendarClock } from "lucide-react";
import useLang from "../../hooks/useLang";

// "My challenge is..." card: the visitor types or picks a starter, then lands on Contact with it filled in.
const ChallengeBox = ({ className = "" }) => {
  const { t } = useLang();
  const navigate = useNavigate();
  const inputRef = useRef(null);
  const [text, setText] = useState("");
  const chips = t("challenge.chips", { returnObjects: true });

  const pick = (chip) => {
    setText(chip);
    inputRef.current?.focus();
  };

  const submit = (e) => {
    e.preventDefault();
    const message = text.trim();
    if (!message) {
      inputRef.current?.focus();
      return;
    }
    // Passed in router state, not the URL, so the visitor's words never land in links or logs.
    navigate("/contact", { state: { message } });
  };

  return (
    <form
      onSubmit={submit}
      className={`rounded-3xl bg-white/[0.04] border border-white/10 p-6 sm:p-7 backdrop-blur-sm ${className}`}
    >
      <label htmlFor="challenge-input" className="font-mono text-[11px] tracking-[0.16em] uppercase text-rose-light">
        {t("challenge.label")}
      </label>
      <input
        id="challenge-input"
        ref={inputRef}
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder={t("challenge.placeholder")}
        maxLength={300}
        autoComplete="off"
        className="mt-3 w-full bg-transparent border-0 border-b border-white/15 pb-3 text-lg font-semibold text-white placeholder:text-white/35 caret-rose-light focus:outline-none focus:border-rose-light transition-colors"
      />
      <div className="flex flex-wrap gap-2 mt-5">
        {chips.map((chip) => (
          <button
            key={chip}
            type="button"
            onClick={() => pick(chip)}
            className={`text-xs font-semibold rounded-full border px-3 py-1.5 transition-colors ${
              text === chip
                ? "border-rose-light bg-rose/15 text-white"
                : "border-white/15 text-white/70 hover:border-white/40 hover:text-white"
            }`}
          >
            {chip}
          </button>
        ))}
      </div>
      <div className="flex flex-wrap items-center gap-5 mt-6">
        <button type="submit" className="btn-rose group">
          {t("challenge.send")}
          <ArrowRight size={15} className={`transition-transform duration-300 group-hover:translate-x-1 rtl:rotate-180`} />
        </button>
        <Link to="/contact?mode=call" className="inline-flex items-center gap-2 text-sm font-semibold text-white/80 hover:text-white">
          <CalendarClock size={16} /> {t("cta.bookCall")}
        </Link>
      </div>
    </form>
  );
};

export default ChallengeBox;
